<div class="otp-card">

    <div class="otp-title">Verifica tu cuenta</div>

    <div class="otp-hint">
        <ng-container *ngIf="sentTo.email && sentTo.whatsApp">
            Te enviamos un código a <b>{{maskedEmail}}</b> y por WhatsApp al <b>{{maskedPhone}}</b>
        </ng-container>
        <ng-container *ngIf="sentTo.email && !sentTo.whatsApp">
            Te enviamos un código a <b>{{maskedEmail}}</b>
        </ng-container>
        <ng-container *ngIf="!sentTo.email && sentTo.whatsApp">
            Te enviamos un código por WhatsApp al <b>{{maskedPhone}}</b>
        </ng-container>
    </div>

    <div class="form-group m-t-16">
        <label class="font-l1">Código de verificación</label>
        <!-- El código es alfanumérico (ej. LE3NDQ) y puede pegarse con espacios
             desde el correo, así que no se limita a 6 ni a teclado numérico. -->
        <input class="form-control otp-input" type="text" autocomplete="one-time-code"
            maxlength="20" placeholder="Código" [(ngModel)]="code"
            autocapitalize="characters" spellcheck="false"
            (input)="localError = null; errorMessage = null">
    </div>

    <div class="otp-error" *ngIf="errorText">{{errorText}}</div>

    <button class="btn-otp-primary m-t-16" type="button"
        [disabled]="!code || working" (click)="onConfirm()">
        {{confirmLabel}}
    </button>

    <!-- Un solo reenvío: el API manda por los dos canales a la vez -->
    <div class="otp-actions m-t-16">
        <a class="otp-link" [class.otp-link-disabled]="!canSend" (click)="sendCode()">
            {{ resendLabel }}
        </a>
    </div>
</div>
